import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const HomepageComp2 = () => {
  const { t } = useTranslation();
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(entry.target);
      }
    });
  });

  useEffect(() => {
    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return (
    <div className={`homepage-component-container homepage-comp2-container relative ${isVisible ? 'fade-in' : ''}`} ref={ref}>

      <div className="absolute right-[15%] top-12 z-0 hidden h-60 w-[60%] rounded-3xl bg-[#caeffc] lg:block"></div>

      <div className='md:grid grid-cols-2 gap-12 relative z-2'>
        <div className='grid grid-cols-2'>
          <div className='homepage-img2 z-4 relative'></div>
          <div className='homepage-img3 z-2 relative'></div>
          <div className="absolute -bottom-24 left-28 z-3 hidden h-[300px] w-[300px] rounded-full border-[40px] border-[#D56B21] shadow-md lg:block"></div>
        </div>
        <div>
          <h1 className='homepage-title2'>
            {t('homepage.comp2.title')}
          </h1>
          <p className='homepage-text1'>
            {t('homepage.comp2.desc1')}
          </p>
          <p className='homepage-text1'>
            {t('homepage.comp2.desc2')}
          </p>

          {/* <p className="inline-block rounded-full bg-gray-100 px-8 py-4 text-lg text-[#D56B21] lg:text-xl xl:text-2xl">
            <span className="mr-2 font-semibold xl:text-4xl">20+</span>
            <span>Years of Commitment to Sustainable Practices</span>
          </p> */}
        </div>
      </div>

    </div>
  )
}

export default HomepageComp2;